import { Container } from "pixi.js";

import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponet";
import { GameIntro } from "./GameIntro";

export class GameIntroComponent extends AbstractDisplayComponent {
    private container: Container;

    public override init() {
        let containerConfig = {
            labelName: "intro_container",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: 1500,
                posY: 1500,
                scale: 1,
            },
            portrait: {
                posX: 1500,
                posY: 1500,
                scale: 1,
            }
        };

        this.container = new GameIntro(containerConfig);
    }

    public getInstance(): Container {
        return this.container;
    }

    public override destroy(): void {
        this.container.destroy({ children: true });
    }
}
